module.exports = __webpack_public_path__ + "img/share-alt-square.38aa2a17.svg";